// extracted by mini-css-extract-plugin
export default {"tax":"_1bOQO"};